import client from './client';

export const listMyOrders = () => client.get('/api/orders/mine');
export const getMyOrder = (orderNumber) => client.get(`/api/orders/mine/${orderNumber}`);
export const guestLookup = (data) => client.post('/api/orders/lookup', data);
